import { action, computed, observable } from "mobx";

/**
 * @deprecated it's only used in 1 or 2 places
 */
export class BaseStore {
  /**
   * Is store loading? (e.g. data loaded?)
   */
  @observable isLoading = true;

  /**
   * In case of any error
   */
  @observable error: Error = null;

  /**
   * Opposite to isLoading
   */
  @computed get isReady() {
    return !this.isLoading;
  }

  /**
   * Sets isLoading to false
   */
  @action.bound setReady(): void {
    this.isLoading = false;
  }

  /**
   * Sets isLoading to true
   */
  @action.bound setLoading(): void {
    this.isLoading = true;
  }

  @action.bound setError(error): void {
    console.warn(error);
    this.error = error;
  }
}
